export default class Responsive {
  constructor() {
    var _this2 = this;

    this.currentBreakpoint = Responsive.getCurrentBreakpoint();

    window.addEventListener('resize', function () {
      var newBreakpoint = Responsive.getCurrentBreakpoint();

      if (_this2.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this2.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this2.currentBreakpoint = newBreakpoint;
    });
  }

  static matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case '2xl':
        return window.matchMedia('screen and (min-width: 1600px)').matches;

      case 'xl':
        return window.matchMedia('screen and (min-width: 1256px)').matches;

      case 'lg':
        return window.matchMedia('screen and (min-width: 1024px)').matches;

      case 'md':
        return window.matchMedia('screen and (min-width: 768px)').matches;

      case 'sm':
        return window.matchMedia('screen and (min-width: 641px)').matches;

      case 'phone':
        return window.matchMedia('screen and (max-width: 640px)').matches;

      case 'pocket':
        return window.matchMedia('screen and (max-width: 767px)').matches;
    }
  }
  static getCurrentBreakpoint() {
    if (window.matchMedia('screen and (min-width: 1600px)').matches) {
      return '2xl';
    }

    if (window.matchMedia('screen and (min-width: 1256px)').matches) {
      return 'xl';
    }

    if (window.matchMedia('screen and (min-width: 1024px)').matches) {
      return 'lg';
    }

    if (window.matchMedia('screen and (min-width: 768px)').matches) {
      return 'md';
    }

    if (window.matchMedia('screen and (min-width: 641px)').matches) {
      return 'sm';
    }

    if (window.matchMedia('screen and (max-width: 640px)').matches) {
      return 'phone';
    }
  }
}
